var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.423828,
    height: 26.028931,
    viewBox: "0 0 38.4238 26.0289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip364_2004"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mingcute:eye-line",
    width: 38.423645,
    height: 26.028919,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "mingcute:eye-line",
    width: 38.423645,
    height: 26.028919,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip364_2004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2119 0.206055C23.6738 0.206055 27.6382 2.21851 30.4604 4.70959C31.8774 5.95996 33.0444 7.36401 33.8672 8.76172C34.6758 10.1338 35.2217 11.6211 35.2217 13.0139C35.2217 14.4067 34.6777 15.8942 33.8672 17.2661C33.0444 18.6638 31.8774 20.0679 30.4604 21.3182C27.6382 23.8093 23.6724 25.8218 19.2119 25.8218C14.75 25.8218 10.7861 23.8093 7.96338 21.3182C6.54639 20.0679 5.37939 18.6638 4.55664 17.2661C3.74658 15.8942 3.20215 14.4067 3.20215 13.0139C3.20215 11.6211 3.74658 10.1338 4.55664 8.76172C5.37939 7.36401 6.54639 5.95996 7.96338 4.70959C10.7861 2.21851 14.7515 0.206055 19.2119 0.206055ZM19.2119 3.40808C15.7153 3.40808 12.4751 4.9978 10.083 7.1095C8.89209 8.15979 7.95068 9.30762 7.31494 10.3867C6.66504 11.4915 6.4043 12.4055 6.4043 13.0139C6.4043 13.6223 6.66504 14.5365 7.31494 15.6411C7.95068 16.7202 8.89209 17.8666 10.083 18.9183C12.4751 21.03 15.7153 22.6199 19.2119 22.6199C22.7085 22.6199 25.9487 21.03 28.3408 18.9183C29.5317 17.8666 30.4731 16.7202 31.1089 15.6411C31.7588 14.5365 32.02 13.6223 32.02 13.0139C32.02 12.4055 31.7588 11.4915 31.1089 10.3867C30.4731 9.30762 29.5317 8.16138 28.3408 7.1095C25.9487 4.9978 22.7085 3.40808 19.2119 3.40808ZM19.2119 8.21094C19.353 8.21094 19.4922 8.21741 19.6299 8.22864C19.2822 8.83838 19.1445 9.54541 19.2383 10.241C19.3315 10.9366 19.6514 11.5822 20.1475 12.0785C20.6436 12.5748 21.2896 12.8943 21.9849 12.9878C22.6807 13.0813 23.3877 12.9437 23.9976 12.5961C24.0815 13.5602 23.8726 14.5271 23.3979 15.3704C22.9229 16.2136 22.2046 16.8938 21.3364 17.3218C20.4688 17.7498 19.4917 17.9055 18.5337 17.7687C17.5757 17.6318 16.6812 17.2087 15.9678 16.5551C15.2544 15.9012 14.7549 15.0471 14.5352 14.1046C14.3154 13.1622 14.3853 12.1754 14.7363 11.2734C15.0869 10.3715 15.7017 9.59644 16.5005 9.05005C17.2993 8.50354 18.2441 8.21106 19.2119 8.21094Z",
    fill: "#282A62",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.0bd34e5cd716a1dc8838cc1ea413a8fe.svg";
export { ForwardRef as ReactComponent };